import {
  JOB_LIST,
  JOB_DETAIL,
  UPDATE_STATE,
  UPDATE_BULK_COPY_CHECKBOX_STATE,
  INIT_JOB_LIST,
  INIT_JOB_ID_LIST,
} from './action-types';

const initialState = {
  jobs: [],
  selectedJobIds: [],
};

const reducer = (state = initialState, { type, payload = null, params = null }) => {
  switch(type) {
    case JOB_LIST:
      return getSelectedList(state, payload, params);
    case JOB_DETAIL:
      return getDetail(state, payload);
    case UPDATE_STATE:
      return updateStateJobs(state, payload);
    case UPDATE_BULK_COPY_CHECKBOX_STATE:
      return updateBulkCopyCheckboxState(state, payload);
    case INIT_JOB_LIST:
      return initSelectedList(state, payload);
    case INIT_JOB_ID_LIST:
      return initSelectedIdList(state, payload);
    default:
      return state;
  }
};

function getSelectedList(state, payload, params) {
  state.jobs = payload

  return Object.assign({}, state)
}

function getDetail(state, payload) {
  return Object.assign({}, state, payload)
}
function updateStateJobs(state, payload) {
  return Object.assign({}, state, payload)
}
function updateBulkCopyCheckboxState(state, payload) {
  return Object.assign({}, state, payload)
}
function initSelectedList(state) {
  const data = {
    jobs: []
  }
  return Object.assign({}, state, data)
}
function initSelectedIdList(state) {
  const data = {
    selectedJobIds: []
  }
  return Object.assign({}, state, data)
}

export default reducer;
